import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { useUpdateFunctions } from "../../functions";

const PayRebatesModal = ({ data }) => {
  const [payRebatesDate, setPayRebatesDate] = useState(new Date());
  const [switchApplyAllTickets, setSwitchApplyAllTickets] = useState(false);
  const [payRebatesResponse, setPayRebatesResponse] = useState({
    AccountsRebated: 0,
    TicketRebated: 0,
    RebatedPerDay: 0,
    ErrorsList: [],
  });
  const [showPayRebatesInfo, setShowPayRebatesInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const { payRebatesTickets } = useUpdateFunctions();

  let chkApplyAllTickets = document.getElementById("switchApplyAllTickets");
  if (chkApplyAllTickets && !switchApplyAllTickets) {
    chkApplyAllTickets.checked = false;
  }

  // This function is called when the user clicks on the PayRebates button
  const payRebates = async () => {
    setLoading(true);

    const res = await payRebatesTickets(
      {
        CutOffDate: dayjs(payRebatesDate).format("MM/DD/YYYY"),
      },
      data.LogonSessionID
    );

    if (res?.error) {
      let errorDet;
      if (res.errorDetails) {
        errorDet = res.errorDetails;
      }
      setPayRebatesResponse({
        AccountsRebated: 0,
        TicketRebated: 0,
        RebatedPerDay: 0,
        ErrorsList: [],
      });
    } else {
      setPayRebatesResponse({
        AccountsRebated: res.AccountsRebated,
        TicketRebated: res.TicketRebated,
        RebatedPerDay: res.RebatedPerDay,
        ErrorsList: res.ErrorsList,
      });
      setShowPayRebatesInfo(true);
    }
    setLoading(false);
  };

  let payRebatesErrorsContent = [];
  if (
    payRebatesResponse.ErrorsList &&
    payRebatesResponse.ErrorsList.length > 0
  ) {
    payRebatesErrorsContent = payRebatesResponse.ErrorsList.map((item, i) => {
      return (
        <tr key={i}>
          <td style={{ textAlign: "center" }}>{item.ErrMsg}</td>
        </tr>
      );
    });
  }

  // const toggleApplyAllTickets = () => {
  //   setSwitchApplyAllTickets(!switchApplyAllTickets);
  // };

  const closeModal = () => {
    setShowPayRebatesInfo(false);
    setPayRebatesResponse({
      AccountsRebated: 0,
      TicketRebated: 0,
      RebatedPerDay: 0,
      ErrorsList: [],
    });
    setPayRebatesDate(new Date());
    setSwitchApplyAllTickets(false);
  };

  return (
    <div>
      <div
        className="modal fade"
        id="payRebatesModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-xs" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5 className="modal-title" id="payRebatesModal">
                Pay Rebates
              </h5>
              {!loading && (
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => closeModal()}
                >
                  &times;
                </button>
              )}
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12" style={{ textAlign: "center" }}>
                  <p
                    className="lead"
                    style={{
                      color: "#8c8c8c",
                      fontSize: "16px",
                    }}
                  >
                    This function will pay rebates on all eligible racing wagers
                    that have not already been paid. If this is the first time
                    you are doing this, please see the cash rebate details from
                    our official site for important information about paying
                    rebates for the first time.
                  </p>
                  <p
                    className="lead"
                    style={{
                      color: "#8c8c8c",
                      fontSize: "16px",
                      marginBottom: "2px",
                    }}
                  >
                    Cutoff Date
                  </p>
                  <div style={{ width: "150px", margin: "0 auto" }}>
                    <DatePicker
                      selected={payRebatesDate}
                      onChange={(date) => {
                        setPayRebatesDate(date);
                      }}
                      className="form-control text-center"
                    />
                  </div>
                  {/* <div className="custom-control custom-switch mt-2">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="switchApplyAllTickets"
                      name="switchApplyAllTickets"
                      value={switchApplyAllTickets}
                      onClick={() => toggleApplyAllTickets()}
                    />
                    <label
                      className="custom-control-label "
                      htmlFor="switchApplyAllTickets"
                      style={{ color: "#8c8c8c", fontSize: "16px" }}
                    >
                      Apply to All Tickets
                    </label>
                  </div> */}
                </div>
              </div>

              {!loading ? (
                showPayRebatesInfo && (
                  <>
                    <hr />
                    <div className="col-sm-12" style={{ textAlign: "center" }}>
                      <p
                        style={{
                          color: "#8c8c8c",
                          fontSize: "16px",
                          margin: "3px",
                        }}
                        className="lead"
                      >
                        Accounts Rebated:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {payRebatesResponse.AccountsRebated}
                        </span>
                      </p>
                      <p
                        className="lead"
                        style={{
                          color: "#8c8c8c",
                          fontSize: "16px",
                          margin: "3px",
                        }}
                      >
                        Ticket Rebated:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {payRebatesResponse.TicketRebated}
                        </span>
                      </p>
                      <p
                        className="lead"
                        style={{
                          color: "#8c8c8c",
                          fontSize: "16px",
                          margin: "3px",
                        }}
                      >
                        Rebated Per Day:{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {payRebatesResponse.RebatedPerDay}
                        </span>
                      </p>
                      {showPayRebatesInfo.ErrorsList &&
                        showPayRebatesInfo.ErrorsList.length === 0 && (
                          <table className="table table-striped table-sm mt-2">
                            <thead
                              style={{
                                position: "sticky",
                                top: "0",
                                background: "#fff",
                                fontSize: "13px",
                              }}
                            >
                              <tr>
                                <th>Errors List</th>
                              </tr>
                            </thead>
                            <tbody className="table-lg">
                              {payRebatesErrorsContent}
                            </tbody>
                          </table>
                        )}
                    </div>
                  </>
                )
              ) : (
                <div
                  className="row d-flex justify-content-center mt-5 mb-5"
                  style={{ textAlign: "center" }}
                >
                  <div className="spinner-grow text-secondary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-info" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                  <div className="spinner-grow text-warning" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className={
                  !loading ? "btn btn-success" : "btn btn-success disabled"
                }
                onClick={() => payRebates()}
              >
                Pay Rebates
              </button>
              <button
                type="button"
                className={
                  !loading ? "btn btn-secondary" : "btn btn-secondary disabled"
                }
                data-dismiss="modal"
                onClick={() => closeModal()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayRebatesModal;
